import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class MiintoCategoryMapApiClient extends AdvancedApiClient {

    static entityType = "MiintoCategoryMap"

    constructor(token, categoryId, id) {
        super();

        this.setEntityType(MiintoCategoryMapApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/category/{cid}/miinto-map/{id}")
                .setRouteParam("cid", categoryId)
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/category/{cid}/miinto-map")
                .setRouteParam("cid", categoryId);
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}